import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-all-courses',
  templateUrl: './view-all-courses.component.html',
  styleUrls: ['./view-all-courses.component.scss']
})
export class ViewAllCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
